<header class="header">
    <dx-toolbar class="header-toolbar">
        @if (menuToggleEnabled) {
            <dxi-item
                location="before"
                widget="dxButton"
                cssClass="menu-button"
                [options]="{
                    icon: 'menu',
                    stylingMode: 'text',
                    onClick: onMenuToggle,
                }"
            >
            </dxi-item>
        }

        <!-- App launcher dropdown -->
        <dxi-item location="before" cssClass="applauncher-item">
            <ng-container *dxTemplate>
                <dx-drop-down-button
                    stylingMode="text"
                    [elementAttr]="{ class: 'menu-button app-launcher' }"
                    [dropDownOptions]="{
                        wrapperAttr: { class: 'menu-dropdown-wrapper app-launcher' },
                        width: '248px',
                        height: 'auto',
                    }"
                    [items]="appLauncherMenuItems"
                    displayExpr="text"
                    [useSelectMode]="false"
                    itemTemplate="appLauncherMenuItem"
                    template="template"
                >
                    <div *dxTemplate="let data of 'template'" class="tab">
                        <i class="cn-icon-ico-appswitcher"></i>
                    </div>
                    <a
                        *dxTemplate="let item of 'appLauncherMenuItem'"
                        class="dropdown-switcher-item"
                        [attr.href]="item.href"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        @if (item.icon) {
                            <i class="switcher-icon {{ item.icon }}"></i>
                        }
                        <span>{{ item.text }}</span>
                    </a>
                </dx-drop-down-button>
            </ng-container>
        </dxi-item>

        <dxi-item location="before" cssClass="logo">
            <a href="/" class="logo-link">
                <img src="assets/images/trusmart-logo.svg" [alt]="title" />
            </a>
        </dxi-item>

        <!-- Main nav items using same routes as app-header -->
        <!-- <dxi-item location="before" locateInMenu="auto" cssClass="dev-menu-item">
            <ng-container *dxTemplate>
                <a class="tab" [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <i class="icon-tab cn-icon-ico-home"></i>
                    <span>Home</span>
                </a>
            </ng-container>
        </dxi-item> -->

        <dxi-item location="before" locateInMenu="auto" cssClass="dev-menu-item">
            <ng-container *dxTemplate>
                <dx-drop-down-button
                    stylingMode="text"
                    [elementAttr]="{ class: 'menu-button' }"
                    [dropDownOptions]="{
                        wrapperAttr: { class: 'menu-dropdown-wrapper' },
                        width: '248px',
                        height: 'auto',
                    }"
                    [items]="ordersMenuItems"
                    displayExpr="text"
                    [useSelectMode]="false"
                    itemTemplate="ordersMenuItem"
                    template="template"
                >
                    <div *dxTemplate="let data of 'template'" class="tab">
                        <i class="icon-tab cn-icon-ico-orders"></i>
                        {{ 'orders' | transloco }}
                        <i class="cn-icon-ico-chevron-down"></i>
                    </div>
                    <a
                        *dxTemplate="let item of 'ordersMenuItem'"
                        class="dropdown-switcher-item"
                        [routerLink]="[item.route]"
                        routerLinkActive="active"
                    >
                        @if (item.icon) {
                            <i class="switcher-icon {{ item.icon }}"></i>
                        }
                        <span>{{ item.text }}</span>
                    </a>
                </dx-drop-down-button>
            </ng-container>
        </dxi-item>

        <dxi-item location="before" locateInMenu="auto" cssClass="dev-menu-item">
            <ng-container *dxTemplate>
                <a class="tab" [routerLink]="['/customers']" routerLinkActive="active">
                    <i class="icon-tab cn-icon-ico-customer"></i>
                    <span>{{ 'customers' | transloco }}</span>
                </a>
            </ng-container>
        </dxi-item>

        <dxi-item location="before" locateInMenu="auto" cssClass="dev-menu-item">
            <ng-container *dxTemplate>
                <a class="tab" [routerLink]="['/articles']" routerLinkActive="active">
                    <i class="icon-tab cn-icon-ico-part"></i>
                    <span>{{ 'articles' | transloco }}</span>
                </a>
            </ng-container>
        </dxi-item>

        <!-- Administration dropdown -->
        <dxi-item location="before" locateInMenu="auto" cssClass="dev-menu-item">
            <ng-container *dxTemplate>
                <dx-drop-down-button
                    stylingMode="text"
                    [elementAttr]="{ class: 'menu-button' }"
                    [dropDownOptions]="{
                        wrapperAttr: { class: 'menu-dropdown-wrapper' },
                        width: '248px',
                        height: 'auto',
                    }"
                    [items]="administrationMenuItems"
                    displayExpr="text"
                    [useSelectMode]="false"
                    itemTemplate="administrationMenuItem"
                    template="template"
                >
                    <div *dxTemplate="let data of 'template'" class="tab">
                        <i class="icon-tab cn-icon-ico-master-data"></i>
                        {{ 'master_data' | transloco }}
                        <i class="cn-icon-ico-chevron-down"></i>
                    </div>
                    <a
                        *dxTemplate="let item of 'administrationMenuItem'"
                        class="dropdown-switcher-item"
                        [routerLink]="[item.route]"
                        routerLinkActive="active"
                    >
                        @if (item.icon) {
                            <i class="switcher-icon {{ item.icon }}"></i>
                        }
                        <span>{{ item.text }}</span>
                    </a>
                </dx-drop-down-button>
            </ng-container>
        </dxi-item>

        <!-- Development dropdown (only in non‑prod) -->
        @if (isDevelopmentEnvironment) {
            <dxi-item location="before" locateInMenu="auto" cssClass="dev-menu-item">
                <ng-container *dxTemplate>
                    <dx-drop-down-button
                        stylingMode="text"
                        [elementAttr]="{ class: 'menu-button' }"
                        [dropDownOptions]="{
                            wrapperAttr: { class: 'menu-dropdown-wrapper' },
                            width: '248px',
                            height: 'auto',
                        }"
                        [items]="developmentMenuItems"
                        displayExpr="text"
                        [useSelectMode]="false"
                        itemTemplate="developmentMenuItem"
                        template="template"
                    >
                        <div *dxTemplate="let data of 'template'" class="tab">
                            <i class="icon-tab dx-icon-tips"></i>
                            {{ 'development' | transloco }}

                            <i class="cn-icon-ico-chevron-down"></i>
                        </div>
                        <a
                            *dxTemplate="let item of 'developmentMenuItem'"
                            class="dropdown-switcher-item"
                            [routerLink]="[item.route]"
                            routerLinkActive="active"
                        >
                            @if (item.icon) {
                                <i class="switcher-icon {{ item.icon }}"></i>
                            }
                            <span>{{ item.text }}</span>
                        </a>
                    </dx-drop-down-button>
                </ng-container>
            </dxi-item>
        }

        <dxi-item location="after" locateInMenu="never">
            <ng-container *dxTemplate>
                <app-language-switcher></app-language-switcher>
            </ng-container>
        </dxi-item>

        <dxi-item location="after" locateInMenu="never">
            <ng-container *dxTemplate>
                <app-theme-switcher></app-theme-switcher>
            </ng-container>
        </dxi-item>

        <!-- Right side icons: settings, help, notifications, user -->
        <dxi-item location="after" locateInMenu="never">
            <ng-container *dxTemplate>
                <a
                    class="tab tab-icon-only"
                    [routerLink]="['/settings/general']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    aria-label="Settings"
                >
                    <i class="icon-tab cn-icon-ico-settings"></i>
                </a>
            </ng-container>
        </dxi-item>

        <!-- <dxi-item location="after" locateInMenu="never">
            <ng-container *dxTemplate>
                <button class="tab tab-icon-only" type="button" aria-label="Help">
                    <i class="icon-tab dx-icon dx-icon-help"></i>
                </button>
            </ng-container>
        </dxi-item>

        <dxi-item location="after" locateInMenu="never">
            <ng-container *dxTemplate>
                <button class="tab tab-icon-only with-badge" type="button" aria-label="Notifications">
                    <i class="icon-tab cn-icon-ico-alarm"></i>
                    <span class="badge">1</span>
                </button>
            </ng-container>
        </dxi-item> -->

        <dxi-item location="after" locateInMenu="never">
            <ng-container *dxTemplate>
                <app-user-panel [menuItems]="userMenuItems" menuMode="context"></app-user-panel>
            </ng-container>
        </dxi-item>
    </dx-toolbar>
</header>
